import React, { useContext, useEffect } from 'react';
import { Modal } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { FoundationApplicationContext } from '../../../context/index.js';
import { getRouteLevel } from '../../../util/index.js';
import './routes.css';
function Routes(props) {
    const context = useContext(FoundationApplicationContext);
    useEffect(() => {
        const popNavigation = context.pushNavigationItem(() => props.onClose());
        return () => popNavigation();
    }, []);
    const returnToTheBeginning = getRouteLevel(props.route) > 2 ? (React.createElement("li", { className: "c-application-bar-routes__route", onClick: props.onReturnClick }, MessageService.translate('tws.application-bar.return-to-the-beginning'))) : null;
    return (React.createElement(Modal, { className: "c-application-bar-routes", focusOnOpen: false, noPadding: true, onClose: props.onClose },
        React.createElement("ul", null,
            props.routes.map((item) => {
                const { name, route } = item;
                return (React.createElement("li", { className: "c-application-bar-routes__route", key: route, onClick: () => props.onClick(item, props.route) }, MessageService.translate(name)));
            }),
            returnToTheBeginning)));
}
export { Routes, };
//# sourceMappingURL=routes.js.map